module.exports = __webpack_public_path__ + "img/seven_start_bg.cbb2c015.png";